module.exports = __webpack_public_path__ + "media/img/seed/12-8ae0e04f14472398c6603df90b2454c1.jpeg";